// ABOUTME: Last step of approve Bol replenishment (the only one without Bol pickup) - choose the picking date.
// ABOUTME: Saves via useApproveBolreplenishmentMutation, sending type + pickDate + id.
import { Box, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import ProgressionTab from "../../../../theme/ProgressionBuilder/ProgressionTab";
import Text from "../../../../theme/text/Text";
import ShDateRangePicker from "../../../../theme/ShDateRangePicker";
import { tokens } from "../../../../../theme";
import { getTranslatedDateAndTime } from "../../../../../utils";

const Content = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (!props.data?.pickDate) {
            const initial = props.customerDeliveryDate
                ? new Date(props.customerDeliveryDate)
                : new Date();
            props.handleDataUpdate({ pickDate: initial });
        }
    }, []);

    const handleDateChange = (date) => {
        props.handleDataUpdate({ pickDate: date[0].formattedStartDate });
    };

    const customerDateLabel = props.customerDeliveryDate
        ? getTranslatedDateAndTime(props.customerDeliveryDate, i18n)?.date
        : null;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {customerDateLabel && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        padding: 1.5,
                        borderRadius: 4,
                        background: theme.palette.mode === "dark" ? colors.blue[100] : colors.blue[100],
                        color: theme.palette.mode === "dark" ? colors.blue[400] : colors.blue[400],
                    }}
                >
                    <InfoOutlinedIcon fontSize="small" />
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Text bold>{t("relation_desired_pick_date")}</Text>
                        <Text>{customerDateLabel}</Text>
                    </Box>
                </Box>
            )}
            <Box
                sx={{
                    width: 1,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 7,
                }}
            >
                <Box
                    sx={{
                        width: 120,
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        pt: 1,
                    }}
                >
                    <Text>{t("choose_pick_date")}</Text>
                </Box>
                <Box
                    sx={{
                        flex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`,
                        borderRadius: 4,
                        display: "flex",
                        height: 32,
                    }}
                >
                    <ShDateRangePicker
                        singleSelect={true}
                        startDate={props.data?.pickDate}
                        select={handleDateChange}
                        size={32}
                    />
                </Box>
            </Box>
            <Box
                sx={{
                    borderRadius: 4,
                    maxWidth: 500,
                    background: colors["orange"][100],
                    color: colors["orange"][400],
                    padding: 2,
                    width: 1,
                    marginTop: 1,
                    fontSize: 14,
                    fontFamily: "Roboto,sans-serif",
                }}
            >
                {t("choose_delivery_date_bol_explanation")}
            </Box>
        </Box>
    );
};

const PickDate = (props) => {
    const { t } = useTranslation();

    // Without Bol pickup this is the only step, so it also sends the one possible type
    if (props.onlyStep) {
        return (
            <ProgressionTab
                tabId="tabPickDate"
                step={1}
                singleView
                subtitle={t("choose_pick_date")}
                updateData={{ bolReplenishmentId: props.bolReplenishmentId, type: "self" }}
            >
                <Content customerDeliveryDate={props.customerDeliveryDate} />
            </ProgressionTab>
        );
    }

    return (
        <ProgressionTab
            tabId="tabPickDate"
            step={2}
            maxSteps={2}
            subtitle={t("choose_pick_date")}
        >
            <Content customerDeliveryDate={props.customerDeliveryDate} />
        </ProgressionTab>
    );
};

export default PickDate;
